import noImage from "@/assets/img/no-image.svg";
import type { Attachment, FirstAttachment } from "@/entities/attachment";
import type { Thread } from "./types";

/**
 * スレッドのタイトルを取得する。
 * 新APIでは Thread schema に body フィールドが無いため、title が無ければ
 * 「(無題)」を返すだけのシンプルな実装。maxLength は将来 ThreadListItem 等で
 * タイトル長を切り詰めたいケースに備えて維持しておく。
 */
export function getThreadTitle(
  thread: Pick<Thread, "title">,
  maxLength: number = 30,
): string {
  if (thread.title) return thread.title.slice(0, maxLength);
  return "(無題)";
}

/**
 * Attachment / FirstAttachment から表示用の画像URLを取得する共通ヘルパー関数。
 * 新APIでは url / thumbnailUrl は絶対URL (nullable) で返ってくるため、
 * UPLOADS_BASE などの連結処理は不要。
 *
 * @param attachment - 画像のAttachmentオブジェクト（FirstAttachment は nullable 自体を含む）
 * @param preferOriginal - true の場合はオリジナル画像、false の場合はサムネイルを優先
 * @returns 画像のURL（取得できない場合は no-image を返す）
 */
export function getImageUrl(
  attachment: Attachment | FirstAttachment | null | undefined,
  preferOriginal: boolean,
): string {
  if (!attachment) return noImage;
  const url = preferOriginal
    ? attachment.url
    : (attachment.thumbnailUrl ?? attachment.url);
  return url ?? noImage;
}
